import { render, staticRenderFns } from "./appealFeedback.vue?vue&type=template&id=164b797f&scoped=true"
import script from "./appealFeedback.vue?vue&type=script&lang=js"
export * from "./appealFeedback.vue?vue&type=script&lang=js"
import style0 from "./appealFeedback.vue?vue&type=style&index=0&id=164b797f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b797f",
  null
  
)

export default component.exports